<mat-accordion class="sumemary-acardion">
    <mat-expansion-panel [expanded]="expand">
        <mat-expansion-panel-header collapsedHeight="104px" expandedHeight="60px">
            <mat-panel-title>
                <div class="top">
                    <span>
                        {{'GENERAL.SUMMARY'| translate}}
                    </span>
                    <div class="head-status">
                        @if(isDirectDeposit){
                        <span class="status direct-deposit-transaction" requestStatusClass
                            [status]="requestSummary.status" [statusType]="'directDeposit'">
                            {{requestSummary.status | requestStatusTextDirectDeposit }}
                        </span>
                        }@else {
                        <span class="status " requestStatusClass [status]="requestSummary.requestStatus"> {{
                            requestSummary.requestStatus | requestStatusText }}</span>
                        }
                    </div>
                </div>
                @if(isDirectDeposit){
                <div class="head-trackingNumber">
                    <span class="label">{{'GENERAL.TRACKING_CODE' | translate}}:</span>
                    <span class="value">{{requestSummary.depositReferrer}} <i class="far fa-copy" CopyTextNew
                            text="{{requestSummary.depositReferrer}}"></i></span>
                </div>
                }@else {
                <div class="head-trackingNumber">
                    <span class="label">{{'REQUEST.TRACKING_NUMBER' | translate}}:</span>
                    <span class="value">{{requestSummary.trackingNumber}} <i class="far fa-copy" CopyTextNew
                            text="{{requestSummary.trackingNumber}}"></i></span>
                </div>
                }
            </mat-panel-title>
        </mat-expansion-panel-header>
        <div class="request-summary">
            <div class="content">
                @if(isDirectDeposit){
                <div class="data">
                    <span class="title">{{'GENERAL.TRACKING_CODE' | translate}}:</span>
                    <span class="value">{{requestSummary.depositReferrer}} <i class="far fa-copy" CopyTextNew
                            text="{{requestSummary.depositReferrer}}"></i></span>
                </div>

                <div class="data">
                    <span class="title">{{'REQUEST.REQUESTED_DATE_TRANSACTION' | translate}}:</span>
                    <span class="value" tcdate [type]="registerDateType"
                        [value]="requestSummary.transactionDateUtc"></span>
                </div>

                <div class="data summary-status">
                    <span class="title">{{'GENERAL.STATUS_TEXT' | translate}}:</span> &nbsp;
                    <span class="status direct-deposit-transaction" requestStatusClass [status]="requestSummary.status"
                        [statusType]="'directDeposit'">
                        {{requestSummary.status | requestStatusTextDirectDeposit }}
                    </span>
                </div>

                <div class="data">
                    <span class="title">{{'GENERAL.STATUS_DATE' | translate}}:</span>
                    <span class="value" tcdate [type]="registerDateType" [value]="requestSummary.updatedOnUtc"></span>
                </div>
                }@else {
                <div class="data">
                    <span class="title">{{'REQUEST.TRACKING_NUMBER' | translate}}:</span>
                    <span class="value">{{requestSummary.trackingNumber}} <i class="far fa-copy" CopyTextNew
                            text="{{requestSummary.trackingNumber}}"></i></span>
                </div>
                <div class="data">
                    <span class="title">{{'REQUEST.REQUEST_DATE' | translate}}:</span>
                    <span class="value" tcdate [type]="registerDateType" [value]="requestSummary.requestDateUtc"></span>
                </div>
                <div class="data summary-status" *ngIf="requestSummary.requestStatus">
                    <span class="title">{{'GENERAL.STATUS_TEXT' | translate}}:</span> &nbsp;
                    <span class="status " requestStatusClass [status]="requestSummary.requestStatus"> {{
                        requestSummary.requestStatus | requestStatusText }}</span>
                </div>

                <div class="data" *ngIf="requestSummary.wallet && !isDetailMode">
                    <span class="title">{{'REQUEST.WALLET' | translate}}:</span>
                    <span class="value">{{requestSummary.wallet}}</span>
                </div>
                <div class="data" *ngIf="!isDetailMode">
                    <span class="title" *ngIf="amountTitle">{{amountTitle | translate}}:</span>
                    <span class="title" *ngIf="!amountTitle">{{'REQUEST.AMOUNT' | translate}}:</span>
                    <span class="value">{{requestSummary.requestedAmount | tcCurrency: requestSummary.requestPrecision}}
                        {{requestSummary.requestedCurrencyCode}}</span>
                </div>

                <div class="data">
                    <span class="title">{{'GENERAL.STATUS_DATE' | translate}}:</span>
                    <span class="value" tcdate [type]="registerDateType" [value]="requestSummary.statusDateUtc"></span>
                </div>
                }



            </div>
        </div>


    </mat-expansion-panel>
</mat-accordion>